import PropTypes from "prop-types";
import React, { useState, useRef } from "react";

import AlertPopover from "components/Global/Alerts/Popover";
import Container from "components/Global/Alerts/Container";
import Header from "components/Global/Alerts/Header";
import Separator from "components/Global/Alerts/Separator";
import ButtonContainer from "components/Global/Alerts/ButtonContainer";
import PrimaryAction from "components/Global/Alerts/PrimaryAction";
import SecondaryAction from "components/Global/Alerts/SecondaryAction";
import { noop } from "utils/General";

const DeleteConfirmation = ({
  children = React.Fragment,
  onConfirm = noop,
  text = "",
  confirmLabel = null,
  popoverStyle = {},
  cancelLabel = "Cancel",
  secondayText = null,
  helperText = null,
  width = "auto"
}) => {
  const [showPopover, setShowPopover] = useState(false);
  const anchorRef = useRef(null);

  const handleClick = e => {
    e.stopPropagation();
    setShowPopover(true);
  };

  const onRequestClose = () => {
    setShowPopover(false);
  };

  const onConfirmHandler = e => {
    e.stopPropagation();
    onRequestClose();
    onConfirm(e);
  };

  return (
    <div onClick={e => e.stopPropagation()}>
      <span onClick={handleClick} ref={anchorRef}>
        {children}
      </span>
      <AlertPopover
        anchorEl={anchorRef.current}
        onClose={onRequestClose}
        open={showPopover}
        style={popoverStyle}
      >
        <Container width={width}>
          <Header>{text}</Header>
          {secondayText && (
            <Header style={{ fontWeight: 400 }}>{secondayText}</Header>
          )}
          {helperText && (
            <Header style={{ fontWeight: 400 }}>{helperText}</Header>
          )}
          <Separator />
          <ButtonContainer>
            <PrimaryAction onClick={onConfirmHandler}>
              {confirmLabel || "Remove"}
            </PrimaryAction>
            <SecondaryAction onClick={onRequestClose}>
              {cancelLabel || "Cancel"}
            </SecondaryAction>
          </ButtonContainer>
        </Container>
      </AlertPopover>
    </div>
  );
};

DeleteConfirmation.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  confirmLabel: PropTypes.string,
  popoverStyle: PropTypes.object,
  cancelLabel: PropTypes.string,
  secondayText: PropTypes.string
};

export default DeleteConfirmation;
